



import React from "react";
import { IoArrowBack } from "react-icons/io5"; // Left Arrow Icon from react-icons
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { BsInstagram } from "react-icons/bs"; // Instagram icon for button

const LinkAccounts = () => {
  const navigate = useNavigate(); // For navigation

  // Instagram OAuth redirection function
  const redirectToInstagramAuth = () => {
    const CLIENT_ID = '1366779784736329'; // Your Instagram App Client ID
    const REDIRECT_URI = 'https://influencer-marketing-hub.vercel.app/InfluencerProfile/'; // Your Redirect URI
    const instagramAuthUrl = `https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments,instagram_business_content_publish,instagram_business_manage_insights`;
    window.location.href = instagramAuthUrl; // Redirect to Instagram OAuth
  };

  return (
    <div className="flex h-screen mb-0 flex-col">
      {/* Custom Header */}
      <div className="bg-gray-100 text-black flex items-center justify-between p-4 fixed w-full top-0 left-0 z-50">
        {/* Left Arrow Icon and Back Button */}
        <div onClick={() => navigate(-1)} className="cursor-pointer flex items-center">
          <IoArrowBack size={24} />
          <span className="ml-2">Back</span>
        </div>
        {/* Right Side Texts (can be dynamic or statics) */}
        <div className="text-right">Link Accounts</div>
      </div>

      {/* Content Section */}
      <div className="bg-white min-h-screen p-6 w-full mt-20"> {/* Added margin-top to avoid overlap with the header */}
        
        {/* Connect with Instagram Button */}
        <Box sx={{ width: '100%', marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
          <Button
            onClick={redirectToInstagramAuth} // Instagram OAuth redirection
            startIcon={<BsInstagram className="text-white" />} // Ensures icon is white
            className="bg-gradient-to-br from-purple-600 to-blue-500 text-white font-medium rounded-lg text-sm px-6 py-3 text-center hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 w-auto" // Adjusted the width to "w-auto"
          >
            <p className='text-white'>Connect with Instagram</p>
          </Button>
        </Box>

        {/* Instruction Text Below the Instagram Button */}
        <div className="mb-6 mt-6 text-center">
          <p className="text-lg font-semibold mb-10">
            Before you continue to link your Instagram account, make sure that you have:
          </p>
        </div>

        {/* Instructions in bordered boxes */}
        <div className="space-y-4 mb-6 mt-12">
          <div className="border p-4 rounded-lg">
            <p>1. Instagram Creator / Business Accounts</p>
          </div>
          <div className="border p-4 rounded-lg">
            <p>2. A Public Facebook Page</p>
          </div>
          <div className="border p-4 rounded-lg">
            <p>3. Your Instagram Account Linked to Your Facebook Page</p>
          </div>
          <div className="border p-4 rounded-lg">
            <p>4. follow instagram guildlines for business accounts</p>
          </div>
          <div className="border p-4 rounded-lg">
            <p>5. Enabled two-factor authentication on instagram</p>
          </div>
          <div className="border p-4 rounded-lg">
            <p>6. Ensure accurate contact info in your facebook page</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkAccounts;
